import type { RenderCell } from '../GroupHeaderRow';

/**
 * Finds the index at which to insert the filler <th> between
 * non-right-pinned and right-pinned column groups.
 *
 * Scans render cells left-to-right, accumulating colSpan.
 * Returns the insertion point where cumulative span reaches
 * or exceeds nonRightPinnedCount.
 *
 * @returns Index into renderCells (0..length). Returns length when
 *          no right-pinned columns exist.
 */
export const findFillerInsertIndex = (renderCells: RenderCell[], nonRightPinnedCount: number): number => {
  let cumSpan = 0;
  for (let i = 0; i < renderCells.length; i++) {
    const cell = renderCells[i];
    const span = cell.type === 'group' ? cell.colSpan : 1;
    cumSpan += span;
    if (cumSpan === nonRightPinnedCount) {
      return i + 1;
    }
    if (cumSpan > nonRightPinnedCount) {
      return i;
    }
  }
  return renderCells.length;
};